(() => {
  const tagName = 'beleaev-delivery-countdown';
  if (customElements.get(tagName)) return;
  const londonFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function londonParts(date) {
    const parts = {};
    londonFormatter.formatToParts(date).forEach(part => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    return parts;
  }
  function wallTimeToInstant(wall) {
    let instant = wall;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      const parts = londonParts(new Date(instant));
      const observed = Date.UTC(parts.year, parts.month - 1, parts.day,
        parts.hour, parts.minute, parts.second);
      instant += wall - observed;
    }
    return new Date(instant);
  }
  function nextCutoff(now) {
    const parts = londonParts(now);
    const day = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    if (parts.hour >= 14) day.setUTCDate(day.getUTCDate() + 1);
    while (day.getUTCDay() === 0 || day.getUTCDay() === 6) {
      day.setUTCDate(day.getUTCDate() + 1);
    }
    const wall = Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), 14);
    const target = wallTimeToInstant(wall);
    const today = Date.UTC(parts.year, parts.month - 1, parts.day);
    return { target, daysAhead: Math.round((day.getTime() - today) / 86400000) };
  }
  class DeliveryCountdown extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-countdown]');
      this.dayOutput = this.querySelector('[data-order-day]');
      if (!this.output || !this.dayOutput) return;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.refresh = () => {
        window.clearInterval(this.timer);
        if (!this.mobile.matches || document.hidden) return;
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      };
      this.mobile.addEventListener('change', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.mobile?.removeEventListener('change', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
    }
    tick() {
      const now = new Date();
      const cutoff = nextCutoff(now);
      const seconds = Math.max(0, Math.ceil((cutoff.target.getTime() - now.getTime()) / 1000));
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const remainingSeconds = seconds % 60;
      this.output.textContent = this.dataset.timerFormat
        .replace('__HOURS__', String(hours))
        .replace('__MINUTES__', String(minutes).padStart(2, '0'))
        .replace('__SECONDS__', String(remainingSeconds).padStart(2, '0'));
      this.dayOutput.textContent = cutoff.daysAhead === 0 ? this.dataset.today :
        cutoff.daysAhead === 1 ? this.dataset.tomorrow :
        new Intl.DateTimeFormat(this.dataset.locale || 'en-GB', {
          timeZone: 'Europe/London', weekday: 'long'
        }).format(cutoff.target);
    }
  }
  customElements.define(tagName, DeliveryCountdown);
})();
